var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtUpto2H(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 0.95,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 0.95,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 0.95,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 0.95,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 0.95,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 0.95,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 0.95,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 0.95,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 1.9583,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 1.9583,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 1.9583,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 1.9583,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 1.9583,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 1.9583,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 1.9583,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 1.9583,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 2.9666,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 2.9666,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 2.9666,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 2.9666,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 2.9666,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 2.9666,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2.9666,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 2.9666,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 3.9749,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 3.9749,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 3.9749,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 3.9749,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 3.9749,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 3.9749,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3.9749,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 3.9749,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 4.98345,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 4.98345,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 4.98345,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 4.98345,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 4.98345,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 4.98345,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4.98345,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 4.98345,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 5.99175,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 5.99175,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 5.99175,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 5.99175,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 5.99175,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 5.99175,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5.99175,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 5.99175,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 7.00005,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 7.00005,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 7.00005,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 7.00005,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 7.00005,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 7.00005,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.00005,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 7.00005,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 8.00835,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 8.00835,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 8.00835,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 8.00835,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 8.00835,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 8.00835,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.00835,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 8.00835,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 9.01665,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 9.01665,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 9.01665,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 9.01665,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 9.01665,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 9.01665,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9.01665,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 9.01665,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 10.025,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 10.025,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 10.025,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 10.025,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 10.025,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 10.025,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10.025,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 10.025,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 11.0333,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 11.0333,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 11.0333,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 11.0333,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 11.0333,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 11.0333,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.0333,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 11.0333,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 12.0416,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 12.0416,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 12.0416,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 12.0416,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 12.0416,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 12.0416,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0416,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 12.0416,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.00005,
    cy: 13.0501,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.8333,
    cy: 13.0501,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66667,
    cy: 13.0501,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.50005,
    cy: 13.0501,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.3333,
    cy: 13.0501,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1667,
    cy: 13.0501,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13.0501,
    r: 0.2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8333,
    cy: 13.0501,
    r: 0.2,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtUpto2H);
export default __webpack_public_path__ + "static/media/ot-upto-2h.15ec34e9eb9de0b9186478d3e3f8e126.svg";
export { ForwardRef as ReactComponent };